<template>
  <div v-lenis-scroll class="tatak_section">
    <div class="takatbanner" :style="desktopBgStyle">
      <div class="takatsection1">
        <img id="takaticon" v-lazy="shopifyData.logoSymbol" alt="Takat Logo" />
        <img v-lazy="shopifyData.mobBg" class="bannerImageMob" alt="Banner Image" />
      </div>
      <div class="takatsection2">
        <img id="takatlogo" v-lazy="shopifyData.logoIcon" alt="Takat Logo 2" />
      </div>
      <div class="takatsection3">
        <p class="takattext">
          {{ shopifyData.info }}
        </p>
      </div>
      <div class="takatsection4">
        <img v-lazy="shopifyData.logo" class="behnoyork" :class="osClass" alt="Behno Logo" />
      </div>
      <div class="sec5" />
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      windowWidth: window.innerWidth,
      osClass: '',
    };
  },
  computed: {
    // Dynamic background image based on window width

    desktopBgStyle() {
      return { backgroundImage: `url(${this.shopifyData.desktopBg})` };
    },
  },
  mounted() {
    this.detectOS();

    this.updateBackgroundImage();

    // Add a resize event listener
    window.addEventListener('resize', this.updateBackgroundImage);

    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();
    // Media query for min-width: 768px
    mm.add('(min-width: 0px) and (max-width: 768px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatbanner',
            start: '0% 0%',
            end: 'bottom 100%',
            scrub: true,
          },
        })
        .to('.bannerImageMob', {
          scale: '1.7',
        });
    });
    // Media query for min-width: 399px
    mm.add('(max-width: 399px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection1',
            start: '50% 50%',
            end: 'bottom 50%',
            scrub: true,
          },
        })
        .to('#takaticon', { x: -58 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection1',
          start: '0% 0%',
          end: 'bottom -100%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection2',
            start: '0% 75%',
            end: '50% 50%',
            scrub: true,
          },
        })
        .to('#takatlogo', { x: 50 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 50%',
            end: '100% 60%',
            scrub: true,
            // markers:true
          },
        })
        .to('#takatlogo', {
          x: 0,
        });
      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection2',
          start: '50% 50%',
          end: '50% 30%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 60%',
            end: '70% 70%',
            scrub: true,
            pin: true,
            pinSpacing: false,
          },
        })
        .to('.takattext', { opacity: 0 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection4',
            start: '0% 100%',
            end: '50% 100%',
            scrub: true,
          },
        })
        .to('#takaticon', { x: 0 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection4',
          start: '42% 55%',
          end: '0% 0%',
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      });
    });

    // Media query for min-width: 599px
    mm.add('(min-width: 400px) and (max-width: 768px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection1',
            start: '50% 50%',
            end: 'bottom 50%',
            scrub: true,
            //markers: true
          },
        })
        .to('#takaticon', { x: -80 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection1',
          start: '0% 0%',
          end: 'bottom -100%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection2',
            start: '0% 75%',
            end: '50% 50%',
            scrub: true,
          },
        })
        .to('#takatlogo', { x: 70 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 50%',
            end: '100% 60%',
            scrub: true,
            // markers:true
          },
        })
        .to('#takatlogo', {
          x: 0,
        });
      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection2',
          start: '50% 50%',
          end: '50% 30%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 60%',
            end: '70% 70%',
            scrub: true,
            pin: true,
            pinSpacing: false,
          },
        })
        .to('.takattext', { opacity: 0 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection4',
            start: '0% 100%',
            end: '50% 100%',
            scrub: true,
          },
        })
        .to('#takaticon', { x: 0 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection4',
          start: '42% 55%',
          end: '0% 0%',
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      });
    });

    // Media query for 600px
    mm.add('(min-width: 769px)', () => {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection1',
            start: '50% 50%',
            end: 'bottom 50%',
            scrub: true,
          },
        })
        .to('#takaticon', { x: -200 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection1',
          start: '0% 0%',
          end: 'bottom -100%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection2',
            start: '0% 75%',
            end: '50% 50%',
            scrub: true,
          },
        })
        .to('#takatlogo', { x: 70 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 50%',
            end: '100% 60%',
            scrub: true,
            // markers:true
          },
        })
        .to('#takatlogo', {
          x: 0,
        });
      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection2',
          start: '50% 50%',
          end: '50% 30%',
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection3',
            start: '0% 70%',
            end: '70% 70%',
            scrub: true,
            pin: true,
            pinSpacing: false,
          },
        })
        .to('.takattext', { opacity: 0 });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.takatsection4',
            start: '0% 100%',
            end: '50% 100%',
            scrub: true,
          },
        })
        .to('#takaticon', { x: 0 });

      gsap.timeline({
        scrollTrigger: {
          trigger: '.takatsection4',
          start: '42% 60%',
          end: '0% 0%',
          pin: true,
          pinSpacing: false,
          scrub: true,
        },
      });
    });
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.updateBackgroundImage);
    clearTimeout(this.resizeTimeout);
  },
  methods: {
    updateBackgroundImage() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        const newWidth = window.innerWidth;
        if (newWidth !== this.windowWidth) {
          this.windowWidth = newWidth;
        }
      }, 200);
    },

    async getDeviceOSModern() {
      if (navigator.userAgentData) {
        const platform = navigator.userAgentData.platform;

        if (platform.includes('Windows')) return 'Windows';
        if (platform.includes('macOS')) return 'macOS';
        if (platform.includes('Android')) return 'Android';
        if (platform.includes('iOS')) return 'iOS';
        if (platform.includes('Linux')) return 'Linux';

        return 'Unknown OS';
      }

      // Fallback to the traditional userAgent method
      return this.getDeviceOS();
    },

    getDeviceOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';
      if (/android/i.test(userAgent)) return 'Android';
      if (/Win/i.test(userAgent)) return 'Windows';
      if (/Mac/i.test(userAgent)) return 'macOS';
      if (/Linux/i.test(userAgent)) return 'Linux';

      return 'Unknown OS';
    },

    async detectOS() {
      const os = await this.getDeviceOSModern();
      if (os === 'macOS') {
        this.osClass = 'mac-os'; // Add the class 'mac-os' for macOS
      } else {
        this.osClass = os.toLowerCase(); // Add the OS name as a class (e.g., 'windows', 'android')
      }
    },
  },
};
</script>

<style scoped>
.mac-os {
  padding-top: 85px;
}

@media screen and (min-device-width: 391px) and (max-device-width: 430px) {
  .behnoyork.ios {
    padding-top: 35px;
  }
}

.windows {
  padding-top: 0;
}

.takatbanner {
  margin-top: -146px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  position: relative;
  overflow: hidden;
}

.bannerImageMob {
  display: none;
}

.takatsection1,
.takatsection2,
.takatsection4 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.takatsection1 {
  height: 100vh;
  position: relative;
}

.takatsection2,
.takatsection4 {
  height: 50vh;
}

.takatsection3,
.sec5 {
  height: 50vh;
  text-align: center;
}

.takattext {
  font-family: 'PP Editorial New', sans-serif;
  font-style: italic;
  max-width: 468px;
  margin: 0 auto;
  color: white;
  line-height: 1.5;
  padding: 20px;
}

.behnoyork {
  max-width: 130px;
  width: 100%;
}

img#takatlogo {
  margin-top: -15px;
}

@media (max-width: 768px) {
  .takatbanner {
    background-image: none !important;
  }

  img#takatlogo {
    margin-top: -9px;
  }

  .bannerImageMob {
    position: absolute;
    top: -2px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    display: block;
    width: 100%;
    height: calc(100% + 2px);
  }

  .takattext {
    line-height: 1.5;
    font-size: 12px;
    padding: 20px;
    padding-top: 45px;
    font-family: 'PP Editorial New', sans-serif;
    font-style: italic;
  }

  #takaticon {
    max-width: 70px;
  }

  #takatlogo {
    max-width: 200px;
  }

  .behnoyork {
    max-width: 70px;
  }
}

@media (max-width: 400px) {
  #takaticon {
    max-width: 41px;
  }

  #takatlogo {
    max-width: 136px;
  }

  .behnoyork {
    max-width: 41px;
    padding-top: 0px;
  }
}
</style>
